import React from "react";
import { Input } from "reactstrap";

const DealTemplateList = ({ templates, selected, setSelected }) => {
	const options = templates.map((obj) => (
		<option key={obj.ID} value={obj.dealID}>
			{obj.name}
		</option>
	));

	return (
		<div className="d-flex justify-content-center mt-2 mb-5">
			<Input
				className="col-4"
				onChange={(e) => setSelected(Number(e.target.value))}
				type="select"
				value={selected}
			>
				<option key="default" value={-1} label="Create New Template" />
				{options != null && options.length > 0 && options}
			</Input>
		</div>
	);
};

export default DealTemplateList;
